import http from "./http";

function detgeofenceList(data) {
  return http.post(`geoFencList`, data);
}

function getAllAlertlist(data) {
  return http.post(`allAlertList`, data);
}

const MasterListService = {
  detgeofenceList,
  getAllAlertlist,
};

export default MasterListService;
